module.exports = __webpack_public_path__ + "img/graduate-8485-yuanmingyuan.06b8d8b5.jpg";